// extracted by mini-css-extract-plugin
module.exports = {"container":"_2fVTA","header":"FkPeQ","fixed":"_2qG8i","zeroHeight":"_3fXQB","inFrontOfCookieBanner":"_1o78u"};